export const NOTIFICATION_TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  ERROR: 'error',
} as const;
export type NOTIFICATION_TYPE = typeof NOTIFICATION_TYPE;
export type A_NOTIFICATION_TYPE = NOTIFICATION_TYPE[keyof NOTIFICATION_TYPE];
